import type { Video, Contact, ActivityFeedItem, KnowledgeSummary } from '@/types'

export const DUMMY_VIDEOS: Video[] = [
  {
    id: 'v1',
    title: 'Visi dan Misi CERAH 2025',
    description: 'Paparan Direktur Eksekutif mengenai arah strategis CERAH untuk tahun 2025 dan rencana jangka panjang organisasi.',
    speaker_name: 'Dr. Ahmad Fauzi',
    speaker_title: 'Direktur Eksekutif',
    iframe_url: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    thumbnail_url: 'https://img.youtube.com/vi/dQw4w9WgXcQ/mqdefault.jpg',
    duration: '24:18',
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'v2',
    title: 'Program Literasi Digital 2024',
    description: 'Review program literasi digital yang telah berjalan dan rencana pengembangan ke depan bersama tim lapangan.',
    speaker_name: 'Siti Rahayu, M.Pd',
    speaker_title: 'Manajer Program Pendidikan',
    iframe_url: 'https://www.youtube.com/embed/9bZkp7q19f0',
    thumbnail_url: 'https://img.youtube.com/vi/9bZkp7q19f0/mqdefault.jpg',
    duration: '18:45',
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'v3',
    title: 'Workshop Tata Kelola Data Organisasi',
    description: 'Panduan pengelolaan data dan arsip organisasi untuk mendukung transparansi dan akuntabilitas CERAH.',
    speaker_name: 'Rizky Pratama, S.Kom',
    speaker_title: 'Kepala Divisi Teknologi',
    iframe_url: 'https://www.youtube.com/embed/kJQP7kiw5Fk',
    thumbnail_url: 'https://img.youtube.com/vi/kJQP7kiw5Fk/mqdefault.jpg',
    duration: '32:07',
    created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'v4',
    title: 'Evaluasi Program Q1 2025',
    description: 'Pemaparan hasil evaluasi program triwulan pertama 2025 oleh tim monitoring dan evaluasi CERAH.',
    speaker_name: 'Maya Lestari',
    speaker_title: 'Koordinator M&E',
    iframe_url: 'https://www.youtube.com/embed/OPf0YbXqDm0',
    thumbnail_url: 'https://img.youtube.com/vi/OPf0YbXqDm0/mqdefault.jpg',
    duration: '41:22',
    created_at: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'v5',
    title: 'Orientasi Staf Baru CERAH',
    description: 'Video pengenalan budaya kerja, nilai-nilai, dan prosedur operasional standar untuk staf baru CERAH.',
    speaker_name: 'Hendra Gunawan',
    speaker_title: 'Manajer SDM',
    iframe_url: 'https://www.youtube.com/embed/jNQXAC9IVRw',
    thumbnail_url: 'https://img.youtube.com/vi/jNQXAC9IVRw/mqdefault.jpg',
    duration: '55:10',
    created_at: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
  },
]

export const DUMMY_CONTACTS: Contact[] = [
  {
    id: 'c1',
    name: 'Dr. Ahmad Fauzi',
    position: 'Direktur Eksekutif',
    organization: 'CERAH',
    email: 'ahmad.fauzi@cerah.org',
    phone: '+62 811-0001-0001',
    photo_url: null,
    notes: null,
    created_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'c2',
    name: 'Siti Rahayu, M.Pd',
    position: 'Manajer Program Pendidikan',
    organization: 'CERAH',
    email: 'siti.rahayu@cerah.org',
    phone: '+62 812-0002-0002',
    photo_url: null,
    notes: null,
    created_at: new Date(Date.now() - 85 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'c3',
    name: 'Rizky Pratama, S.Kom',
    position: 'Kepala Divisi Teknologi',
    organization: 'CERAH',
    email: 'rizky.pratama@cerah.org',
    phone: '+62 813-0003-0003',
    photo_url: null,
    notes: null,
    created_at: new Date(Date.now() - 80 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'c4',
    name: 'Maya Lestari',
    position: 'Koordinator M&E',
    organization: 'CERAH',
    email: 'maya.lestari@cerah.org',
    phone: '+62 814-0004-0004',
    photo_url: null,
    notes: null,
    created_at: new Date(Date.now() - 75 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'c5',
    name: 'Hendra Gunawan',
    position: 'Manajer SDM',
    organization: 'CERAH',
    email: 'hendra.gunawan@cerah.org',
    phone: '+62 815-0005-0005',
    photo_url: null,
    notes: null,
    created_at: new Date(Date.now() - 70 * 24 * 60 * 60 * 1000).toISOString(),
  },
]

export const DUMMY_ACTIVITY: ActivityFeedItem[] = [
  {
    id: 'a1',
    action: 'upload',
    item_id: 'd1',
    item_title: 'Laporan Tahunan CERAH 2024',
    item_category: 'laporan',
    content_type: 'laporan',
    created_by: 'Maya Lestari',
    created_at: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'a2',
    action: 'upload',
    item_id: 'd2',
    item_title: 'Panduan Digitalisasi Arsip Organisasi',
    item_category: 'dokumen',
    content_type: 'dokumen',
    created_by: 'Rizky Pratama',
    created_at: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'a3',
    action: 'upload',
    item_id: 'd3',
    item_title: 'Data Penerima Manfaat Q1 2025',
    item_category: 'bank_data',
    content_type: 'bank_data',
    created_by: 'Siti Rahayu',
    created_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'a4',
    action: 'upload',
    item_id: 'd4',
    item_title: 'Infografik Capaian Program 2024',
    item_category: 'infografik',
    content_type: 'infografik',
    created_by: 'Hendra Gunawan',
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'a5',
    action: 'upload',
    item_id: 'd5',
    item_title: 'Studi Kasus Dampak Literasi Digital',
    item_category: 'publikasi',
    content_type: 'publikasi',
    created_by: 'Dr. Ahmad Fauzi',
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'a6',
    action: 'upload',
    item_id: 'd6',
    item_title: 'Dokumentasi Kegiatan Workshop Mei 2025',
    item_category: 'media',
    content_type: 'media',
    created_by: 'Maya Lestari',
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
  },
]

export const DUMMY_SUMMARY: KnowledgeSummary[] = [
  { content_type: 'bank_data',  cnt: 42 },
  { content_type: 'dokumen',    cnt: 138 },
  { content_type: 'publikasi',  cnt: 27 },
  { content_type: 'laporan',    cnt: 64 },
  { content_type: 'infografik', cnt: 19 },
  { content_type: 'media',      cnt: 85 },
]
